import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tour_detailsstyles.css';
import img1 from '../assets/hunza1.jpg';
import img2 from '../assets/hunza2.jpg';
import img3 from '../assets/hunza3.jpg';

const TourDetails1 = () => {
  const [activeImage, setActiveImage] = useState(img1);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  const images = [img1, img2, img3];

  const handleImageClick = (index) => {
    setActiveImage(images[index]);
  };

  const handlePackageSelect = (packageData) => {
    const tourData = {
      ...packageData,
      tour_name: 'Explore the Majestic Gilgit'  // Add the tour name here
    };
    setSelectedPackage(tourData);
    navigate('/booking', { state: { packageData: tourData } });  // Pass the updated packageData
  };

  return (
    <div className="tour-details">
      <div className="tour-header">
        <h1>Hunza Valley Adventure</h1>
        <p><strong>Description:</strong> Explore the beautiful Hunza Valley, known for its stunning landscapes, rich culture, and serene environment.</p>
      </div>

      {/* Overview Section */}
      <section className="overview">
        <h2>Overview</h2>
        <p>Hunza Valley, often referred to as heaven on earth, is a paradise for nature lovers and adventure seekers. Nestled in the Gilgit-Baltistan region, Hunza offers breathtaking views, rich culture, and a serene environment...</p>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
        <h2>Gallery</h2>
        <div className="image-gallery">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Hunza Valley ${index + 1}`}
              onClick={() => handleImageClick(index)}
              className={activeImage === image ? 'active' : ''}
            />
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <h2>Pricing</h2>
        <div className="pricing-details">
          <div className="price-item">
            <h3>Standard Package</h3>
            <p><strong>Price:</strong> PKR 50,000 per person</p>
            <p>
              <strong>Details:</strong> Accommodation in 3-star hotels, guided tours, and transportation in a private SUV. Breakfast and dinner included. Duration: 7 days.
              <br />
              <strong>Visiting Spots:</strong> Baltit Fort, Karimabad, Attabad Lake, Passu Cones, Khunjerab Pass.
            </p>
            <button onClick={() => handlePackageSelect({
              name: 'Standard Package',
              price: 'PKR 50,000 per person',
              duration: '7 days',
              accommodation: '3-star hotels',
              transportation: 'Private SUV',
              facilities: [
                'Guided tours and transportation',
                'Breakfast and Dinner included'
              ],
              spots: ['Baltit Fort', 'Karimabad', 'Attabad Lake', 'Passu Cones', 'Khunjerab Pass']
            })} className="book-now-btn">Select Package</button>
          </div>

          <div className="price-item">
            <h3>Deluxe Package</h3>
            <p><strong>Price:</strong> PKR 75,000 per person</p>
            <p>
              <strong>Details:</strong> Accommodation in 5-star hotels, all-inclusive meals, private guided tours, and luxury transportation in a private SUV. Duration: 7 days.
              <br />
              <strong>Visiting Spots:</strong> Baltit Fort, Karimabad, Attabad Lake, Passu Cones, Khunjerab Pass.
            </p>
            <button onClick={() => handlePackageSelect({
              name: 'Deluxe Package',
              price: 'PKR 75,000 per person',
              duration: '7 days',
              accommodation: '5-star hotels',
              transportation: 'Private SUV',
              facilities: [
                'All-inclusive meals',
                'Private guided tours and luxury transportation'
              ],
              spots: ['Baltit Fort', 'Karimabad', 'Attabad Lake', 'Passu Cones', 'Khunjerab Pass']
            })} className="book-now-btn">Select Package</button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>Testimonials</h2>
        <blockquote>
          "An unforgettable experience! Hunza is breathtaking, and the tour was perfectly organized."
          <cite> - John Doe</cite>
        </blockquote>
        <blockquote>
          "From the beautiful landscapes to the cultural experiences, this tour had it all."
          <cite> - Jane Smith</cite>
        </blockquote>
      </section>

      {/* Map Section */}
      <section className="map">
        <h2>Map</h2>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6656615.628702972!2d69.03220479310505!3d36.0001624457514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e684d02faefb6f%3A0x400c3b0b934a15dd!2sHunza!5e0!3m2!1sen!2s!4v1693385746689!5m2!1sen!2s"
          width="100%" 
          height="450" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          title="Hunza Valley Map">
        </iframe>
      </section>

      {/* FAQs Section */}
      <section className="faqs">
        <h2>FAQs</h2>
        <details>
          <summary>What is included in the tour package?</summary>
          <p>The package includes accommodation, meals, guided tours, and transportation within Hunza.</p>
        </details>
        <details>
          <summary>What should I pack for the trip?</summary>
          <p>Pack warm clothing, comfortable shoes for trekking, and a camera to capture the stunning scenery.</p>
        </details>
        <details>
          <summary>How do I book the tour?</summary>
          <p>You can book the tour through our website or contact our customer support for assistance.</p>
        </details>
      </section>

      {/* Booking Information Section */}
      <section className="contact-info">
        <h2>Contact Information</h2>
        <p>For more details or to book your tour, contact us at <a href="tel:+1234567890">(123) 456-7890</a> or email us at <a href="mailto:info@travelsite.com">info@travelsite.com</a>.</p>
      </section>
    </div>
  );
}

export default TourDetails1;
